import React, { Component } from 'react';
import { APIProvider, Map, MapCameraChangedEvent, AdvancedMarker, Pin } from '@vis.gl/react-google-maps';
class Information extends Component {
    render() {
        return (
            <div className="col-md-6">
                <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                <div className="themesflat-headings style-2 clearfix">
                    <h2 className="heading">İLETİŞİM</h2>
                    <div className="sep has-width w80 accent-bg clearfix" />
                </div>
                <div className="themesflat-spacer clearfix" data-desktop={36} data-mobile={35} data-smobile={35} />
                <div className="themesflat-tabs style-1 w168 clearfix">
                    {/* <ul className="tab-title clearfix">
                        <li className="item-title active">
                            <span className="inner">Head Office</span>
                        </li>
                        <li className="item-title">
                            <span className="inner">Colombia</span>
                        </li>
                        <li className="item-title">
                            <span className="inner">Mexico</span>
                        </li>
                    </ul> */}
                    <div className="tab-content-wrap clearfix">
                        <div className="tab-content">
                            <div className="item-content">
                                <ul>
                                    <li className="clearfix">
                                        <div className="inner">
                                            <span className="fa fa-map-marker" />
                                            <span className="text">Namık Kemal Mahallesi
                                                10. Sokak No: 1, Daire: 5
                                                Esenyurt / İstanbul
                                                T                   ürkiye </span>
                                        </div>
                                    </li>
                                    <li className="clearfix">
                                        <div className="inner">
                                            <span className="fa fa-phone" />
                                            <span className="text">Tel : 0530 244 87 89 - 0545 837 70 75</span>
                                        </div>
                                    </li>
                                    <li className="clearfix">
                                        <div className="inner">
                                            <span className="fa fa-envelope" />
                                            <span className="text">Email : tacarmuhendislik@gmail.com</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <div className="tab-content">
                            <div className="item-content">
                                <ul>
                                    <li className="clearfix">
                                        <div className="inner">
                                            <span className="fa fa-map-marker" />
                                            <span className="text">PO BOX 16122 COLLINS STREET WEST VICTORIA, NEWYORK </span>
                                        </div>
                                    </li>
                                    <li className="clearfix">
                                        <div className="inner">
                                            <span className="fa fa-phone" />
                                            <span className="text">CALL US : (+61) 3 8376 6284</span>
                                        </div>
                                    </li>
                                    <li className="clearfix">
                                        <div className="inner">
                                            <span className="fa fa-envelope" />
                                            <span className="text">EMAIL : SUPPORT@THEMESFLAT.COM</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                        {/* <div className="tab-content">
                            <div className="item-content">
                                <ul>
                                    <li className="clearfix">
                                        <div className="inner">
                                            <span className="fa fa-map-marker" />
                                            <span className="text">PO BOX 16122 COLLINS STREET WEST VICTORIA, NEWYORK </span>
                                        </div>
                                    </li>
                                    <li className="clearfix">
                                        <div className="inner">
                                            <span className="fa fa-phone" />
                                            <span className="text">CALL US : (+61) 3 8376 6284</span>
                                        </div>
                                    </li>
                                    <li className="clearfix">
                                        <div className="inner">
                                            <span className="fa fa-envelope" />
                                            <span className="text">EMAIL : SUPPORT@THEMESFLAT.COM</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="themesflat-spacer clearfix" data-desktop={20} data-mobile={35} data-smobile={35} />
                {/* <div className="themesflat-map" /> */}
                    <div style={{height:"250px"}}>
                     <APIProvider apiKey={'AIzaSyCdbi8Mt2wifeyDXSJDbqpCMU0REk8NECA'} >
                    <Map
                        mapId={"424fe12de88fd8427a7240bf"}
                        defaultZoom={17}
                        defaultCenter={{ lat: 41.038547, lng: 28.651017 }}
                        onCameraChanged={(ev) =>
                            console.log('camera changed:', ev.detail.center, 'zoom:', ev.detail.zoom)
                        }
                    >
                     
                          
               
                        <AdvancedMarker
                            key={"Namık Kemal Mahallesi 10. Sokak No: 1"}
                            position={{ lat: 41.038547, lng: 28.651017 }}>

                            <Pin background={'#FBBC04'} glyphColor={'#000'} borderColor={'#000'} />

                        </AdvancedMarker>
                    </Map>
                </APIProvider>
                   </div>
               
            </div>
        );
    }



}

export default Information;